import React, { FC } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { IconPencil } from '../../Icons';
import { DirectionData } from '../../types/PersonalData';

interface Props {
  tipoForm: string;
  tipo?: string;
  setTipo?: (tipo: string) => void;
  directionData: DirectionData;
  setOnLoad: (onLoad: boolean) => void;
}
const DirectionModalForm: FC<Props> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { setTipo, tipoForm, directionData, setOnLoad } = props;
  const showForm = (data: DirectionData, type: string) => {
    setOnLoad(true);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    document
      .getElementById(`${type}-${data.idDireccion}`)
      .classList.add('visible');
    document.body.classList.add('fix');
    sessionStorage.setItem('sessiontoken', uuidv4());
  };
  const resetError = (data: DirectionData) => {
    const labelError = document.getElementById(
      `codPostal-error-not-selected-${data.idDireccion}`,
    ) as HTMLLabelElement;
    if (labelError !== null) {
      labelError.classList.add('hide');
    }
    const componenteCp = document.getElementById(
      `cod-entrega-${data.idDireccion}`,
    ) as HTMLLabelElement;
    if (componenteCp !== null) {
      componenteCp.classList.remove('error');
    }
  };
  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <a
        onClick={() => {
          if (setTipo) {
            setTipo(tipoForm);
          }
          resetError(directionData);
          showForm(directionData, tipoForm);
        }}
        className="bloque-datos__action edit-datos"
      >
        <div className="icon icon__stroke icon-round">
          <IconPencil />
        </div>
      </a>
    </>
  );
};

export default DirectionModalForm;
